<div class="shadow-lg background-white">
    @if (status === Status.Pending) {
    <app-progress-bar></app-progress-bar>
    }
    <div class="px-4 px-lg-5 py-5">
        @if (status !== Status.Success) {
        <div class="row">
            <div class="col-12 d-flex justify-content-end">
                <button class="button-unstyled" (click)="closeModal()">
                    <img src="./assets/images/close.svg" alt="Close Icon" class="icon-medium" />
                </button>
            </div>
            <div class="col-12">
                <h3>Jetzt bewerten</h3>
                <p>Hilf uns mit deiner Bewertung andere Menschen zu überzeugen.</p>
            </div>
            <div class="col-12">
                <div class="row">
                    <div class="col-12 mt-4">
                        <rating [(ngModel)]="stars" [max]="5"></rating>
                        <span class="ms-3">{{ stars ? stars + '/5' : '(bitte wählen)' }}</span>
                    </div>
                </div>
                <form [formGroup]="formGroup">
                    <div class="row">
                        <div class="col-12 mt-4">
                            <input
                                type="text"
                                formControlName="name"
                                placeholder="Name"
                                class="w-100"
                            />
                            @if (formGroup?.controls.name?.touched && formGroup?.controls.name?.hasError('required')) {
                            <span class="text-size-xs pt-2">
                                Bitte Name eingeben
                            </span>
                            }
                        </div>
                        <div class="col-12 mt-4">
                            <textarea
                                formControlName="rating"
                                rows="5"
                                placeholder="Bewertung"
                            >
                            </textarea>
                            @if (formGroup?.controls.rating?.touched && formGroup?.controls.rating?.hasError('required')) {
                            <span class="text-size-xs pt-2">
                                Bitte gib eine Bewertung ein
                            </span>
                            }
                        </div>
                        <div class="col-12 mt-5">
                            <p class="text-size-xs" [innerText]="'Informationen zum Datenschutz findest du'"><a class="text-decoration-underline" routerLink="/datenschutz">hier</a>.</p>
                        </div>
                        <div class="col-12 mt-4 d-flex justify-content-end'">
                            <button
                                [disabled]="formGroup.invalid || status === Status.Pending || !stars"
                                (click)="submit()"
                                class="btn btn-black"
                            >
                                Abschicken
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-12 mt-3">
                @if (status === Status.Error) {
                <p>
                    Sorry ☹️ Ein Fehler ist aufgetreten. Bitte versuche es später erneut.
                </p>
                }
            </div>
        </div>
        } @if (status === Status.Success) {
        <div class="row d-flex justify-content-center">
            <div class="col-6">
                <img src="./assets/images/dancing.svg" alt="" class="w-100" />
            </div>
            <div class="col-12 mt-4 text-center">
                <h3>Danke für deine Hilfe!</h3>
                <p>Vielen Dank für deine Bewertung. Du hilfst vielen Menschen dabei die richtige Entscheidung zu treffen.</p>
                <button class="btn btn-black" (click)="closeModal()">
                    Schließen
                </button>
            </div>
        </div>
        }
    </div>
</div>
